import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const headers = { 'Content-Type': 'application/json' };

const handle = (err) => {
    if (err.response?.data) throw err.response.data;
    throw err;
};

// GET the caller's workflow level for the "StockTransfer" operation.
// spGetIndentLevelsNew resolves MasterOperationID by matching the role against the
// level-1 approver of MOID 676 (Store Keeper / "SK") or 678 (Central Store Keeper /
// "CSK") — IndentPresentLevel === IndentDefineLevel means the caller IS the CSK, which
// switches the whole page into the CSK flow (ToCC + depreciation columns).
export const getIndentLevelsIT = async (Roleid) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetIndentLevelsIT?Roleid=${encodeURIComponent(Roleid)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET the "Transfer From" cost centers available to this user (spGetCSKCCs)
export const getFromCCList = async (UID, RID) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetCentralCostCenterMenuIT?UID=${encodeURIComponent(UID)}&RID=${encodeURIComponent(RID)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET the "Transfer To" cost centers for the CSK flow, scoped to the chosen From CC
export const getToCCList = async (UID, RID, CC) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetCentralCostCenterCodesITTO?UID=${encodeURIComponent(UID)}&RID=${encodeURIComponent(RID)}&CC=${encodeURIComponent(CC)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET item categories for the search-by-category dropdown
export const getItemCategories = async () => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetIndentcategoriesDetailsIT`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET item search autocomplete (Typ: '1' = by code, '2' = by name; Cat: category id)
export const getAutoCompleteItemTransfer = async (Pfx, Typ, Cat, CC) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetAutoCompleteItemTransfer?Pfx=${encodeURIComponent(Pfx)}&Typ=${encodeURIComponent(Typ)}&Cat=${encodeURIComponent(Cat)}&CC=${encodeURIComponent(CC)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// POST — stage one item into ItemsTransferIssue (Refno IS NULL) for the From CC
// payload: { ItemCode, FromCC, fullsearch, ItemCategoryCode }
export const saveItemsTransferItems = async (payload) => {
    try {
        const res = await axios.post(
            `${API_BASE_URL}/Purchase/SaveItemsTransferItems`,
            payload,
            { headers, timeout: 30000 }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET staged items for the SK (Store Keeper) flow — simple grid, no depreciation
export const getItemTransferDetails = async (CCode, RID) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetItemTransferDetails?CCode=${encodeURIComponent(CCode)}&RID=${encodeURIComponent(RID)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET staged items for the CSK (Central Store Keeper) flow — includes Basic price,
// used client-side to compute Before/After Depreciation per row
export const getItemTransferDetailscsk = async (CCode, RID) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetItemTransferDetailscsk?CCode=${encodeURIComponent(CCode)}&RID=${encodeURIComponent(RID)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET the max depreciation percent + the configured Central Store CC for a From/To
// CC pair. The CSK creation page always probes with ToCC = 'CC00' (a placeholder —
// only FromCC vs. the returned CentralStoreCC decides the branch), matching the
// legacy ItemsTransferCSK action exactly.
export const getItemDepPercentbyCC = async (FromCC, ToCC) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetItemDepPercentbyCC?FromCC=${encodeURIComponent(FromCC)}&ToCC=${encodeURIComponent(ToCC)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// POST — remove a staged (not-yet-transferred) line item
// payload: { ItId }
export const deleteItemsTransferItem = async (payload) => {
    try {
        const res = await axios.post(
            `${API_BASE_URL}/Purchase/DeleteItemsTransferItem`,
            payload,
            { headers, timeout: 30000 }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// POST — finalize the transfer for the SK (non-CSK) flow
// payload: { ItId, IssQuantity, StockType, FromCC, Date, Remarks, Createdby, Days, RoleID }
export const saveItemsTransfer = async (payload) => {
    try {
        const res = await axios.post(
            `${API_BASE_URL}/Purchase/SaveItemsTransfer`,
            payload,
            { headers, timeout: 30000 }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// POST — finalize the transfer for the CSK flow (adds ToCC + depreciation fields)
// payload: { ItId, IssQuantity, StockType, FromCC, ToCC, Date, Remarks, Createdby, Days,
//            RoleID, Rowid, DepAmounts, EffAmount, Depcsk, Amount }
export const saveCSKItemsTransfer = async (payload) => {
    try {
        const res = await axios.post(
            `${API_BASE_URL}/Purchase/SaveCSKItemsTransfer`,
            payload,
            { headers, timeout: 30000 }
        );
        return res.data;
    } catch (err) { handle(err); }
};
